import { Grid } from "@material-ui/core";
import { ClienteEdit } from "./components/cliente-edit/cliente-edit";

type Props = {
  id: string
}

export const ClientesEditar = ({ id }: Props) => {

  return (
    <div style={{
      width: '100%',
      display: 'flex',
      justifyContent: 'center'
    }}>
      <Grid container spacing={1}
        style={{
          maxWidth: 1400,
          padding: 16,
        }}>
        <ClienteEdit id={id} />
      </Grid>
    </div>
  );
};
